import React from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import TopAppBar from '../components/TopAppBar';
import BottomNavBar from '../components/BottomNavBar';
import Footer from '../components/Footer';
import { fetchCategories } from '../api/contractorProfile';
import { Category } from '../types/contractor';

const categoryIcon = (name: string): string => {
  const map: Record<string, string> = {
    'general building': 'foundation',
    'renovation': 'home_repair_service',
    'residential': 'house',
    'commercial': 'apartment',
    'design-and-build': 'architecture',
    'design and build': 'architecture',
    'other services': 'grid_view',
    'plumbing': 'plumbing',
    'electrical': 'electrical_services',
    'roofing': 'roofing',
    'painting': 'format_paint',
    'flooring': 'layers',
  };
  return map[name.toLowerCase()] ?? 'construction';
};

export async function categoriesPageLoader() {
  const categories = await fetchCategories();
  return { categories };
}

const CategoriesPage: React.FC = () => {
  const { categories } = useLoaderData() as { categories: Category[] };
  const navigate = useNavigate();

  return (
    <div className="bg-background text-on-background min-h-screen pb-24 md:pb-0">
      <TopAppBar />
      <main className="max-w-7xl mx-auto px-container-margin py-10 md:py-16">
        <h1 className="font-headline-sm text-headline-sm-mobile md:font-headline-md md:text-headline-md text-primary mb-3">
          All Categories
        </h1>
        <p className="text-on-surface-variant font-body-md mb-10">
          Browse all service categories and find the right contractor for your project.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {categories.map(cat => (
            <button
              key={cat.id}
              onClick={() => navigate(`/contractors?categoryId=${cat.id}`)}
              className="bg-surface border border-outline-variant rounded-xl p-5 flex flex-col items-center gap-3 hover:shadow-md hover:border-secondary transition-all cursor-pointer active:scale-95"
            >
              <div className="w-12 h-12 bg-secondary-container/20 rounded-full flex items-center justify-center">
                <span className="material-symbols-outlined text-secondary" data-icon={categoryIcon(cat.name)}>
                  {categoryIcon(cat.name)}
                </span>
              </div>
              <span className="font-label-bold text-sm text-on-surface text-center leading-tight">{cat.name}</span>
            </button>
          ))}
        </div>
      </main>
      <Footer />
      <BottomNavBar />
    </div>
  );
};

export default CategoriesPage;
